<script setup>
import {useChatStore} from "@/stores/chat.js";

const chatStore = useChatStore();
chatStore.activeMobileSidebar = true
</script>

<template>
  <div class="h-full flex flex-col items-center justify-center xl:space-y-2 space-y-6">
    <img src="@/assets/images/svg/blank.svg" alt=""/>
    <h4 class="text-2xl text-slate-600 dark:text-slate-300 font-medium">
      No message yet...
    </h4>
    <p class="text-sm text-slate-500 lg:pt-0 pt-4">
      <span class="hidden lg:block">don't worry, just take a deep breath & say "Hello"</span>
      <span
          class="btn btn-dark cursor-pointer lg:hidden"
          @click="chatStore.toggleMobileSidebar()"
      >Start Conversation</span>
    </p>
  </div>
</template>

<style scoped lang="scss">

</style>